import { Heart } from "lucide-react";

const Footer = () => {
  const goTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-[#F4F1EA]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="font-serif-display text-4xl md:text-5xl font-light tracking-tight leading-tight max-w-lg">
              Help us keep families together.
            </p>
            <a
              href="#donate"
              onClick={(e) => goTo(e, "#donate")}
              data-testid="footer-donate-btn"
              className="mt-8 inline-flex items-center gap-2 bg-[#C85A3C] text-[#F4F1EA] rounded-full px-7 py-3.5 text-sm uppercase tracking-[0.15em] hover:scale-105 transition-transform duration-300"
            >
              Donate <Heart size={15} className="fill-current" />
            </a>
          </div>
          <div className="md:col-span-3 md:col-start-8">
            <p className="text-xs uppercase tracking-[0.25em] text-[#F4F1EA]/50 mb-5">Explore</p>
            <ul className="space-y-3 text-sm text-[#F4F1EA]/80">
              {[
                { l: "Mission", h: "#mission" },
                { l: "Services", h: "#services" },
                { l: "The Gap", h: "#gap" },
                { l: "Contact", h: "#contact" },
              ].map((i) => (
                <li key={i.h}>
                  <a href={i.h} onClick={(e) => goTo(e, i.h)} className="link-underline">{i.l}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-[#F4F1EA]/50 mb-5">Partners</p>
            <ul className="space-y-3 text-sm text-[#F4F1EA]/80">
              <li>DCP&amp;P</li>
              <li>NJ DDD</li>
              <li>PerformCare</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F4F1EA]/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#F4F1EA]/50">
          <span>© {new Date().getFullYear()} Independence Way. All rights reserved.</span>
          <span>New Jersey · United States</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
